exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .sw-better-input-char-counter{margin:6px 0 0;font-size:.95em;color:rgba(48,48,48,.5);line-height:.95em;height:0;overflow:visible}#pufferfish .sw-better-input-char-counter.outside-limits{color:#ac99d1}", ""]);
